import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initPixel } from "./utils/tracking";
import { captureAttribution, sendTestLead } from "./utils/leadCapture";
import { isDebug } from "./utils/debug";
import { WEBHOOK_URL } from "./components/ApplicationWizard/useApplicationWizard";
declare global {
  interface Window {
    svipTestWebhook?: () => void;
  }
}

// Tracking starts before React renders so PageView fires as early as possible.
captureAttribution();
initPixel();

// With ?debug=1, run svipTestWebhook() in the console to send a sample payload.
if (isDebug()) {
  window.svipTestWebhook = () => sendTestLead(WEBHOOK_URL);
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-417" data-mp="2tz4yky6dwyro" />);
}